import { render, staticRenderFns } from "./jisti-video-confreness.html?vue&type=template&id=5ffff810&scoped=true&external"
import script from "./jisti-video-confreness.js?vue&type=script&lang=js&external"
export * from "./jisti-video-confreness.js?vue&type=script&lang=js&external"
import style0 from "./jisti-video-confreness.scss?vue&type=style&index=0&id=5ffff810&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffff810",
  null
  
)

export default component.exports